import { Machine, assign } from 'xstate'

export const IDLE = 'idle'
export const LOADING = 'loading'
export const SUCCESS = 'success'
export const FAILURE = 'failure'

export const statusValidator = (status) => {
  const validStatus = [IDLE, LOADING, SUCCESS, FAILURE]

  return validStatus.includes(status)
}

export default Machine({
  context: {
    data: undefined,
    request: undefined,
    error: undefined,
  },
  initial: IDLE,
  states: {
    [IDLE]: {
      on: {
        SEND: {
          target: LOADING,
          actions: assign({
            request: (_context, event) => event,
          }),
        },
      },
    },
    [LOADING]: {
      on: {
        SEND: {
          target: LOADING,
          actions: assign({
            request: (_context, event) => event,
          }),
        },
      },
      invoke: {
        src: 'service',
        onDone: {
          target: SUCCESS,
          actions: [
            assign({
              data: (_context, event) => {
                return event.data
              },
              error: undefined,
            }),
            {
              type: 'notifySuccess',
              amount: (_, event) => {
                return event
              },
            },
          ],
        },
        onError: {
          target: FAILURE,
          actions: [
            assign({
              error: (_context, event) => event.data,
            }),
            {
              type: 'notifyError',
              amount: (_, event) => {
                return event
              },
            },
          ],
        },
      },
    },
    [SUCCESS]: {
      on: {
        SEND: {
          target: LOADING,
          actions: assign({
            request: (_context, event) => event,
          }),
        },
      },
      entry: 'notifySuccess',
      after: {
        2000: {
          target: IDLE,
        },
      },
    },
    [FAILURE]: {
      on: {
        SEND: {
          target: LOADING,
          actions: assign({
            request: (_context, event) => event,
          }),
        },
      },
    },
  },
})
